<template>
  <div>
    <ValidationObserver v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(addNewBill)">
        <div class="md-layout">
          <div class="md-layout-item md-size-33 md-small-size-100">
            <md-card>
              <md-card-header class="md-card-header-icon md-card-header-green">
                <div class="card-icon clickable" @click="closeBillDetail()">
                  <md-icon>arrow_back</md-icon>
                </div>
                <h4 class="title">Đơn hàng: {{ form.orderId }}</h4>
                <md-button
                  v-if="false"
                  class="md-danger md-sm"
                  @click="closeBillDetail()"
                  style="float: right"
                >
                  Đóng
                </md-button>
              </md-card-header>
              <md-card-content class="md-layout">
                <div class="md-layout-item md-size-100">
                  <div class="md-layout">
                    <div
                      class="md-layout-item md-size-40 md-xsmall-size-100"
                      v-if="!isAddBill"
                    >
                      <md-field>
                        <label>Mã đơn hàng:</label>
                        <md-input
                          v-if="form.orderId"
                          v-model="form.orderId"
                          type="text"
                          :disabled="!isAddBill"
                          required
                        ></md-input>
                        <p v-else>Đang tạo</p>
                      </md-field>
                    </div>
                    <div class="md-layout-item md-size-55 md-xsmall-size-100">
                      <md-field>
                        <label>Trạng thái đơn hàng:</label>
                        <md-select v-model="form.status" :disabled="true">
                          <md-option :value="0" disabled
                            >Đơn hàng mới</md-option
                          >
                          <md-option :value="1" disabled>Đã xác nhận</md-option>
                          <md-option :value="2" :disabled="form.status !== 1"
                            >Đang vận chuyển</md-option
                          >
                          <md-option :value="3" :disabled="form.status !== 2"
                            >Hoàn tất</md-option
                          >
                          <md-option :value="4" disabled>Đã hủy</md-option>
                        </md-select>
                      </md-field>
                    </div>
                  </div>
                  <div class="md-layout">
                    <div class="md-layout-item md-size-100 md-xsmall-size-100">
                      <md-autocomplete
                        v-model="form.customerName"
                        :md-options="listCustomerName"
                        :md-open-on-focus="true"
                        @md-changed="getCustomerName()"
                        required
                      >
                        <label>Tên khách hàng</label>
                      </md-autocomplete>
                    </div>
                    <div
                      class="md-layout-item md-size-50 md-xsmall-size-100"
                      v-if="form.creator === 'Admin'"
                    >
                      <md-field>
                        <label>Người tạo đơn:</label>
                        <md-input
                          disabled
                          v-model="form.creator"
                          type="text"
                        ></md-input>
                      </md-field>
                    </div>
                    <div
                      class="md-layout-item md-size-50 md-xsmall-size-100"
                      v-else
                    >
                      <md-field>
                        <label>Người tạo đơn:</label>
                        <md-input
                          disabled
                          v-model="form.salerName"
                          type="text"
                        ></md-input>
                      </md-field>
                    </div>
                    <div class="md-layout-item md-size-44 md-xsmall-size-150">
                      <md-field>
                        <label>Người bán hàng</label>
                        <md-select
                          v-model="form.salerCode"
                          @md-selected="selectEmployee"
                          :disabled="!isAddBill"
                          required
                        >
                          <md-option
                            :key="index"
                            v-for="(item, index) in listEmployee"
                            :value="item.employeeCode"
                          >
                            {{
                              item.employeeCode +
                              " - " +
                              item.name +
                              " (" +
                              item.permission +
                              ")"
                            }}
                          </md-option>
                        </md-select>
                      </md-field>
                    </div>
                    <!-- <div class="md-layout-item md-size-50 md-xsmall-size-100">
                    <md-field>
                      <label>Mã nhân viên:</label>
                      <md-input v-model="form.salerCode" type="text"></md-input>
                    </md-field>
                  </div> -->
                  </div>
                  <div
                    class="md-layout-item md-size-100 md-xsmall-size-100"
                    v-if="userDeposit !== null"
                  >
                    <md-field>
                      <label>Số dư tài khoản</label>
                      <md-input
                        :value="formatMoney(userDeposit)"
                        readonly
                      ></md-input>
                    </md-field>
                  </div>
                  <div
                    class="md-layout-item md-size-100 md-xsmall-size-100"
                    v-if="userDeposit !== null"
                  >
                    <md-field>
                      <label>Giá trị các đơn đang xử lý</label>
                      <md-input
                        :value="formatMoney(moneyHanging)"
                        readonly
                      ></md-input>
                    </md-field>
                  </div>
                  <div
                    class="md-layout-item md-size-100 md-xsmall-size-100"
                    v-if="userDeposit !== null"
                  >
                    <md-field>
                      <label>Số dư khả dụng</label>
                      <md-input
                        :value="formatMoney(userDeposit - moneyHanging)"
                      ></md-input>
                    </md-field>
                  </div>
                </div>
              </md-card-content>
            </md-card>
          </div>
          <div class="md-layout-item md-size-33 md-small-size-100">
            <md-card>
              <md-card-header>
                <h4 class="title">Thông tin đặt hàng</h4>
              </md-card-header>
              <md-card-content class="md-layout">
                <div class="md-layout-item md-size-100">
                  <div class="md-layout">
                    <div class="md-layout-item md-size-50 md-xsmall-size-100">
                      <md-field>
                        <label>Ngày đặt hàng:</label>
                        <md-input
                          :value="formatDate(new Date(form.orderDate))"
                          type="text"
                          disabled
                        ></md-input>
                      </md-field>
                    </div>
                    <div class="md-layout-item md-size-50 md-xsmall-size-100">
                      <md-field>
                        <label>Ngày xác nhận:</label>
                        <md-input
                          disabled
                          v-model="form.validDate"
                          type="text"
                        ></md-input>
                      </md-field>
                    </div>
                  </div>
                  <!-- <div class="md-layout">
                    <div class="md-layout-item md-size-50">
                      <md-field>
                        <label>Giá trị chiết khấu:</label>
                        <md-input
                          v-model="valueFormatted.discountValue"
                          type="text"
                          :readonly="form.status"
                        ></md-input>
                      </md-field>
                    </div>
                    <div class="md-layout-item md-size-50">
                      <md-field>
                        <label>Tổng chiết khấu:</label>
                        <md-input
                          :value="formatMoney(form.discountAmount)"
                          type="text"
                          disabled
                        ></md-input>
                      </md-field>
                    </div>
                  </div> -->
                  <div class="md-layout">
                    <div class="md-layout-item md-size-50">
                      <md-field>
                        <label>VAT (%):</label>
                        <md-input
                          :disabled="form.status === 3 || form.status === 4"
                          v-model="form.vat"
                          type="number"
                          pattern="^[+-]?\d+(\.\d+)?$"
                          :oninput="
                            form.vat < 0 ? (form.vat = form.vat * -1) : ''
                          "
                          min="0"
                          required
                        ></md-input>
                      </md-field>
                    </div>
                    <div class="md-layout-item md-size-50">
                      <md-field>
                        <label>Tổng giá trị VAT:</label>
                        <md-input
                          :value="formatMoney(form.vatAmount)"
                          type="text"
                          disabled
                        ></md-input>
                      </md-field>
                    </div>
                  </div>
                  <div class="md-layout-item">
                    <md-field>
                      <label>Phương thức thanh toán:</label>
                      <md-select
                        v-model="form.paymentMethod"
                        :disabled="form.status === 3 || form.status === 4"
                      >
                        <md-option value="Công nợ">Công nợ</md-option>
                        <md-option value="Thu tiền ngay"
                          >Thu tiền ngay</md-option
                        >
                      </md-select>
                    </md-field>
                  </div>
                  <div class="md-layout">
                    <div class="md-layout-item">
                      <md-datepicker
                        v-model="form.paymentTime"
                        :md-disabled-dates="
                          form.status == 0 ? () => false : () => true
                        "
                        :md-immediately="true"
                      >
                        <label>Thời hạn thanh toán:</label>
                      </md-datepicker>
                    </div>
                  </div>
                  <div class="md-layout-item">
                    <md-field>
                      <label>Giá trị đơn hàng:</label>
                      <md-input
                        :value="formatMoney(form.amount)"
                        type="text"
                        disabled
                      ></md-input>
                    </md-field>
                  </div>
                  <div class="md-layout-item">
                    <md-field>
                      <label>Thông tin kèm theo:</label>
                      <md-input
                        v-model="form.additionalInfo"
                        :disabled="form.status === 3 || form.status === 4"
                      ></md-input>
                    </md-field>
                  </div>
                </div>
              </md-card-content>
            </md-card>
          </div>
          <div class="md-layout-item md-size-33 md-small-size-100">
            <md-card>
              <md-card-header>
                <h4 class="title">Thông tin người nhận</h4>
              </md-card-header>
              <md-card-content class="md-layout">
                <div class="md-layout-item md-size-100 md-small-size-100">
                  <div class="md-layout-item">
                    <md-field>
                      <label>Tên:</label>
                      <md-input
                        v-model="form.receivedName"
                        :disabled="form.status === 3 || form.status === 4"
                        required
                      >
                      </md-input>
                    </md-field>
                  </div>
                  <div class="md-layout-item">
                    <md-field>
                      <label>Địa chỉ:</label>
                      <md-input
                        v-model="form.receivedAddress"
                        :disabled="form.status === 3 || form.status === 4"
                        required
                      >
                      </md-input>
                    </md-field>
                  </div>
                  <div class="md-layout-item">
                    <md-field>
                      <label>Số điện thoại:</label>
                      <md-input
                        v-model="form.receivedPhone"
                        :disabled="form.status === 3 || form.status === 4"
                        required
                      >
                      </md-input>
                    </md-field>
                  </div>
                  <div class="md-layout-item">
                    <label style="margin-right: 15px"
                      >Phương thức vận chuyển:</label
                    >
                    <md-radio
                      v-model="form.deliveryMethod"
                      value="Tự lấy"
                      :disabled="form.status === 3 || form.status === 4"
                      >Tự lấy</md-radio
                    >
                    <md-radio
                      v-model="form.deliveryMethod"
                      value="Công ty giao"
                      :disabled="form.status === 3 || form.status === 4"
                      >Công ty giao</md-radio
                    >
                  </div>
                </div>
              </md-card-content>
            </md-card>
          </div>
        </div>
        <div class="md-layout">
          <div class="md-layout-item md-size-100">
            <md-card class="md-size-100">
              <md-card-content>
                <div class="md-layout">
                  <div
                    class="md-layout-item md-size-100"
                    v-if="form.cartItems !== []"
                    :aria-disabled="form.status === 3 || form.status === 4"
                  >
                    <div>
                      <h5>Danh sách sản phẩm:</h5>
                    </div>
                    <table
                      :key="isShowDialog"
                      id="customers"
                      v-bind:class="{
                        disabled: form.status === 3 || form.status === 4,
                      }"
                    >
                      <tr>
                        <th>STT</th>
                        <th>Mã sản phẩm</th>
                        <th>Tên sản phẩm</th>
                        <th style="width: 90px">Số lượng tồn</th>
                        <th style="width: 125px">CTKM</th>
                        <th>Giá niêm yết</th>
                        <th style="width: 125px">Đơn vị tính</th>
                        <th style="width: 90px">Số lượng đặt</th>
                        <th style="width: 125px">Chiết khấu (%)</th>
                        <th style="width: 150px">Giá bán</th>
                        <th style="width: 150px">Tổng GT chiết khấu</th>
                        <!-- <th>Khuyến mại (%)</th>
                    <th>GT khuyến mại</th> -->
                        <th>Tổng tiền</th>
                        <th style="width: 100px"></th>
                      </tr>
                      <tr
                        :key="index"
                        v-for="(item, index) in form.cartItems"
                        class="clickable text-center"
                        v-bind:class="{
                          disabled: form.status === 3 || form.status === 4,
                        }"
                        @dblclick="
                          form.status === 3 || form.status === 4
                            ? disabled
                            : editCartItem(item, index)
                        "
                      >
                        <!-- STT -->
                        <td>
                          {{ index + 1 }}
                        </td>
                        <!-- Ma san pham -->
                        <td>
                          {{ item.productId }}
                        </td>
                        <!-- Ten san pham -->
                        <td>
                          {{ item.productName }}
                        </td>
                        <!-- Tồn kho -->
                        <td class="number">
                          {{ item.warehouse }}
                        </td>
                        <!-- Loai khuyen mai -->
                        <td class="number">
                          {{
                            !isEdit[index].value
                              ? item.promotion
                                ? item.promotion[0]
                                : ""
                              : ""
                          }}
                        </td>
                        <!-- Gia niêm yết -->
                        <td class="number">
                          {{ formatMoney(item.productCost) }}
                        </td>
                        <!-- Đơn vị tính -->
                        <td class="number">
                          {{ !isEdit[index].value ? item.unit : "" }}
                        </td>
                        <!-- So luong đặt -->
                        <td class="number">
                          {{ !isEdit[index].value ? item.number : "" }}
                        </td>
                        <!-- ty le chiet khau -->
                        <td class="number">
                          {{ Math.round(item.discountValue * 100) / 100 }}
                        </td>
                        <!-- item.productCost < 0 ? (item.productCost *= -1) : '' -->
                        <!-- Don gia ban -->
                        <td class="number">
                          {{
                            !isEdit[index].value
                              ? formatMoney(
                                  Math.round(
                                    item.productCost -
                                      (item.discountValue * item.productCost) /
                                        100
                                  )
                                )
                              : ""
                          }}
                        </td>
                        <td class="number">
                          {{ formatMoney(item.discountAmount) }}
                        </td>
                        <!-- Tổng tiền -->
                        <td class="number">
                          {{ formatMoney(item.amount) }}
                        </td>
                        <!-- Hanh dong -->
                        <td>
                          <i
                            style="color: blue; padding: 5px"
                            class="fas fa-arrow-circle-up"
                            v-show="!isEdit[index].value"
                            @click="
                              form.status === 3 || form.status === 4
                                ? disabled
                                : moveUpItem(index)
                            "
                          >
                          </i>
                          <i
                            style="color: blue; padding: 5px"
                            class="fas fa-arrow-circle-down"
                            v-show="!isEdit[index].value"
                            @click="
                              form.status === 3 || form.status === 4
                                ? disabled
                                : moveDownItem(index)
                            "
                          >
                          </i>
                          <i
                            style="color: red; padding: 5px"
                            class="far fa-trash-alt"
                            v-show="!isEdit[index].value"
                            @click="
                              form.status === 3 || form.status === 4
                                ? disabled
                                : deleteItem(index)
                            "
                          >
                          </i>
                          <i
                            style="color: green"
                            class="fas fa-check"
                            v-show="isEdit[index].value"
                            @click="conpleteEdit(index)"
                          >
                          </i>
                        </td>
                      </tr>
                    </table>

                    <modal-add-products
                      v-if="isAddProducts || isChangeItem"
                      :key="isAddProducts"
                      :isChangeItem="isChangeItem"
                      :itemChange="itemChange"
                      @smallAlertModalHide="smallAlertModalHide"
                      @confirmChangeItem="confirmChangeItem"
                    ></modal-add-products>
                  </div>
                </div>
              </md-card-content>
              <div style="display: inline-block">
                <md-card-actions>
                  <div class="md-layout">
                    <div class="md-layout-item md-size-50 md-small-size-100">
                      <md-button
                        class="md-success md-dense"
                        @click="addProduct"
                        :disabled="form.status === 3 || form.status === 4"
                      >
                        Thêm
                        <md-tooltip>Thêm sản phẩm</md-tooltip>
                      </md-button>
                    </div>
                    <div class="md-layout-item md-size-50 md-small-size-100">
                      <md-button
                        v-show="form.status !== 4"
                        class="md-success md-dense"
                        @click="printBill()"
                        style="float: right; margin-right: 10px"
                      >
                        In đầy đủ
                      </md-button>

                      <md-button
                        v-show="form.status !== 4"
                        class="md-dense"
                        @click="printBill('in thô')"
                        style="float: right; margin-right: 10px"
                      >
                        In vắn tắt
                      </md-button>
                    </div>
                  </div>
                </md-card-actions>
              </div>
            </md-card>
          </div>
        </div>
        <div class="md-layout">
          <div class="md-layout-item md-size-100">
            <md-card>
              <md-card-content>
                <div class="md-layout">
                  <div class="md-layout-item md-size-50 md-small-size-100">
                    <div style="padding: 10px 10px 10px 0px">
                      <md-button
                        class="md-info md-sm"
                        @click="addNewBill()"
                        style="float: right"
                        v-if="isAddBill"
                      >
                        Thêm đơn hàng
                        <md-tooltip>Thêm đơn hàng</md-tooltip>
                      </md-button>

                      <md-button
                        class="md-info md-dense"
                        style="float: left; margin: 0 10px"
                        @click="saveInfoChange"
                        :disabled="form.status === 4"
                        v-if="
                          !isAddBill && (form.status === 0 || form.status === 1)
                        "
                      >
                        Lưu
                        <md-tooltip>Lưu thông tin chỉnh sửa</md-tooltip>
                      </md-button>
                      <md-button
                        class="md-success md-dense"
                        style="float: left; margin: 0 10px"
                        v-show="form.status !== 4 && form.status !== 3"
                        @click="confirmBill()"
                        v-if="!isAddBill"
                        :disabled="flagLoading"
                      >
                        {{
                          form.status === 0
                            ? "Xác nhận"
                            : form.status === 1
                            ? "Giao hàng"
                            : "Hoàn tất"
                        }}
                      </md-button>
                    </div>
                  </div>
                  <div class="md-layout-item md-size-50 md-small-size-100">
                    <md-button
                      class="md-danger md-dense"
                      style="float: right; margin: 10px 0px 10px 30px"
                      @click="cancelBill"
                      v-if="
                        !isAddBill &&
                        (form.status === 0 ||
                          form.status === 1 ||
                          form.status === 2)
                      "
                    >
                      Hủy Đơn
                      <md-tooltip>Hủy đơn hàng</md-tooltip>
                    </md-button>
                  </div>
                </div>
              </md-card-content>
            </md-card>
          </div>
        </div>
      </form>
    </ValidationObserver>
    <ChangeCartItem
      :showDialog="isShowDialog"
      :cartSelected="cartSelected"
      v-if="isShowDialog"
      @updateCartItem="updateCartItem"
      @cancelUpdateCartItem="cancelUpdateCartItem"
    />
  </div>
</template>
<script>
import Swal from "sweetalert2";
import { mapGetters } from "vuex";
export default {
  props: ["billSelected", "db", "isAddBill"],
  components: {
    ModalAddProducts: () => import("./ModalAddProducts"),
    ChangeCartItem: () => import("./changeCartItem"),
  },
  created() {
    //
    let bits = localStorage.getItem("bits");
    this.db
      .collection(process.env.VUE_APP_USER + bits)
      .get()
      .then((doc) => {
        doc.forEach((item) => {
          if (
            item.data().permission === "Nhân viên bán hàng" &&
            this.isAddBill
          ) {
            this.listEmployee.push({
              employeeCode: item.data().employeeCode,
              name: item.data().name,
              permission: item.data().permission,
            });
          } else if (!this.isAddBill) {
            this.listEmployee.push({
              employeeCode: item.data().employeeCode,
              name: item.data().name,
              permission: item.data().permission,
            });
          }
          if (
            item.data().permission === "Cộng tác viên" &&
            this.form.salerCode === item.data().employeeCode
          ) {
            this.userDeposit = parseInt(item.data().deposit);
            this.determineBalance(this.form.salerCode);
          }
        });
      });
    //
    if (this.billSelected.id) {
      this.form = JSON.parse(JSON.stringify(this.billSelected.data));
      this.form.cartItems.forEach((item) => {
        this.db
          .collection(process.env.VUE_APP_WINE + bits)
          .where("productId", "==", item.productId)
          .get()
          .then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              this.$set(item, "warehouse", doc.data().warehouse);
            });
          });
        this.isEdit.push({
          value: false,
        });
      });
      this.formatValues();

      this.db
        .collection(process.env.VUE_APP_ORDER + bits)
        .where("customerCode", "==", this.billSelected.data.customerCode)
        .get()
        .then((doc) => {
          doc.forEach((item) => {
            if (item.data().status !== 4) {
              this.debt += item.data().amount;
            }
          });
        });
      //

      this.db
        .collection(process.env.VUE_APP_CUSTOMER + bits)
        .where("customerId", "==", this.billSelected.data.customerCode)
        .get()
        .then((doc) => {
          doc.forEach((item) => {
            this.debt += item.data().debt;
            this.debtLimit = parseInt(item.data().debtLimit);
          });
        });
    }
    if (this.isAddBill) {
      this.form.creator = "Admin";
    }
    this.db
      .collection("--stats--")
      .doc(process.env.VUE_APP_LIST_CUSTOMER + bits)
      .get()
      .then((docRef) => {
        if (docRef.exists) {
          docRef.data().listCustomer.forEach((customer) => {
            this.listCustomerName.push(customer.customerName);
            this.listCustomerCode.push({
              id: customer.customerId,
              name: customer.customerName,
            });
          });
        }
      });
    this.caculatValue();
  },
  data() {
    let dateFormat = this.$material.locale.dateFormat || "yyyy-MM-dd";
    return {
      cartSelected: {},
      indexSelected: null,
      isShowDialog: false,
      userDeposit: null,
      moneyHanging: 0,
      listEmployee: [],
      disabledDates: (date) => {
        const day = date.getDay();
        return day == 0 || day == 6;
      },
      listCustomerName: [],
      listCustomerCode: [],
      debt: 0,
      debtLimit: 0,
      listBillOfCurrentCustomer: [],
      isAddProducts: false,
      itemChange: "",
      isChangeItem: false,
      productCost: [],
      form: {
        isPayment: false,
        orderId: "",
        paymentTime: "", // thời hạn thanh toán
        discountValue: 0,
        discountAmount: 0,
        status: 0,
        customerCode: "",
        customerName: "",
        salerName: "",
        salerCode: "",
        orderDate: new Date().valueOf(),
        validDate: null,
        vat: 0,
        vatAmount: 0,
        paymentMethod: "Công nợ",
        amount: 0,
        additionalInfo: "",
        receivedName: "",
        receivedAddress: "",
        receivedPhone: null,
        deliveryMethod: "Công ty giao",
        cartItems: [],
        transportTime: "",
        completedTime: "",
      },
      isEdit: [],
      valueFormatted: {
        vat: 0,
        vatAmount: 0,
        discountValue: 0,
        discountAmount: 0,
        amount: 0,
        cartItems: [],
      },
    };
  },
  methods: {
    log(x) {
      console.log(x);
    },
    determineBalance(employeeCode) {
      this.db
        .collection(process.env.VUE_APP_ORDER)
        .where("salerCode", "==", employeeCode)
        .where("status", ">=", 1)
        .where("status", "<=", 2)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            if (doc.data().paymentMethod === "Công nợ") {
              this.moneyHanging += parseInt(doc.data().amount);
            }
          });
        });
    },
    checkEmpty(e) {
      if (e === null) {
        this.$messageError("Hoàn thành các trường bắt buộc");
        return false;
      }
    },
    validateForm() {
      for (const key in this.form) {
        if (
          key !== "additionalInfo" ||
          key !== "validDate" ||
          key !== "paymentTime" ||
          key !== "receivedName" ||
          key !== "receivedAddress" ||
          key !== "receivedPhone"
        ) {
          this.checkEmpty(this.form[key]);
        }
      }
    },
    selectEmployee(item) {
      console.log(item);
      this.isHaveAnyChange = true;
      this.listEmployee.forEach((employee) => {
        if (employee.employeeCode === item) {
          this.form.salerName = employee.name;
        }
      });
    },
    addNewBill() {
      if (!this.form.cartItems.length) {
        this.$messageError("Bạn chưa thêm sản phẩm");
        return false;
      } else if (
        !this.form.customerName ||
        !this.form.salerCode ||
        !this.form.receivedName ||
        !this.form.receivedPhone ||
        !this.form.receivedAddress
      ) {
        this.$messageError("Bạn cần điền đủ thông tin để tạo đơn hàng");
        return false;
      } else {
        let bits = localStorage.getItem("bits");
        Swal.fire({
          title: "Tạo đơn mới",
          type: "warning",
          showCancelButton: true,
          confirmButtonClass: "md-button md-success",
          cancelButtonClass: "md-button md-danger",
          confirmButtonText: "OK",
          buttonsStyling: false,
        }).then((result) => {
          if (result.value) {
            let bits = localStorage.getItem("bits");
            let confirm = this.db.collection(process.env.VUE_APP_ORDER + bits);
            this.$store.dispatch("FLAG_LOADING", true);
            confirm
              .add(this.form)
              .then(() => {
                this.$store.dispatch("FLAG_LOADING", false);
                this.$messageSuccess("Tạo đơn hàng thành công");
                this.$emit("addBillClose");
              })
              .catch((error) => {
                this.$store.dispatch("FLAG_LOADING", false);
                console.log(error);
                this.$messageError("Có lỗi xảy ra, vui lòng thử lại");
              });
          }
        });
      }
    },
    getCustomerName() {
      let check = false;
      this.listCustomerCode.forEach((item) => {
        if (item.name === this.form.customerName) {
          this.form.customerCode = item.id;
          check = true;
          let bits = localStorage.getItem("bits");
          this.db
            .collection(process.env.VUE_APP_CUSTOMER + bits)
            .where("customerId", "==", item.id)
            .get()
            .then((querySnapshot) => {
              querySnapshot.forEach((doc) => {
                this.form.receivedName = doc.data().customerName;
                this.form.receivedAddress = doc.data().address;
                this.form.receivedPhone = doc.data().phone;
              });
            });
        }
      });
      if (!check) {
        this.form.customerCode = "KHÁCH LẺ";
      }
    },
    cacualateDiscountValue(item) {
      this.valueFormatted.cartItems[
        this.form.cartItems.indexOf(item)
      ].discountValue =
        (item.discountAmount * 100) / (item.number * item.productCost);
    },

    cacualateTotalValue(item, value) {
      //console.log(value);
      if (value > item.productCost) value = item.productCost;
      if (value < 0) value = 0;
      this.valueFormatted.cartItems[
        this.form.cartItems.indexOf(item)
      ].discountValue =
        (((item.productCost - value) * 100) / item.productCost) * 100;
    },
    printBill(param) {
      let routeData = this.$router.resolve({
        name: "Print",
        query: {
          orderId: this.form.orderId,
          state: param === "in thô" ? "in_so_bo" : "in",
        },
      });
      window.open(routeData.href, "_blank");
    },
    deleteItem(index) {
      Swal.fire({
        title: "Xóa sản phẩm",
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "md-button md-success",
        cancelButtonClass: "md-button md-danger",
        confirmButtonText: "OK",
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.isEdit.splice(index, 1);
          this.form.cartItems.splice(index, 1);
          this.valueFormatted.cartItems.splice(index, 1);
        }
      });
    },
    moveUpItem(index) {
      var length = this.form.cartItems.length;
      var item = this.form.cartItems[index];
      if (index == 0) {
        this.isEdit.splice(index, 1);
        this.form.cartItems.splice(index, 1);
        this.valueFormatted.cartItems.splice(index, 1);
        this.isEdit.push(item);
        this.form.cartItems.push(item);
        this.valueFormatted.cartItems.push(item);
      } else {
        this.isEdit.splice(index, 1);
        this.form.cartItems.splice(index, 1);
        this.valueFormatted.cartItems.splice(index, 1);
        this.isEdit.splice(index - 1, 0, item);
        this.form.cartItems.splice(index - 1, 0, item);
        this.valueFormatted.cartItems.splice(index - 1, 0, item);
      }
    },
    moveDownItem(index) {
      var length = this.form.cartItems.length;
      var item = this.form.cartItems[index];
      if (index == length - 1) {
        this.isEdit.splice(index, 1);
        this.form.cartItems.splice(index, 1);
        this.valueFormatted.cartItems.splice(index, 1);
        this.isEdit.splice(0, 0, item);
        this.form.cartItems.splice(0, 0, item);
        this.valueFormatted.cartItems.splice(0, 0, item);
      } else {
        this.isEdit.splice(index, 1);
        this.form.cartItems.splice(index, 1);
        this.valueFormatted.cartItems.splice(index, 1);
        this.isEdit.splice(index + 1, 0, item);
        this.form.cartItems.splice(index + 1, 0, item);
        this.valueFormatted.cartItems.splice(index + 1, 0, item);
      }
    },
    cancelBill() {
      Swal.fire({
        title: "Hủy đơn hàng",
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "md-button md-success",
        cancelButtonClass: "md-button md-danger",
        confirmButtonText: "OK",
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.form.status = 4;
          let bits = localStorage.getItem("bits");
          let confirm = this.db.collection(process.env.VUE_APP_ORDER + bits);
          this.$store.dispatch("FLAG_LOADING", true);
          let tmpObject = Object.assign({}, this.form);
          delete tmpObject.orderId;
          confirm
            .doc(this.billSelected.id)
            .update({
              status: 4,
            })
            .then(() => {
              this.$store.dispatch("FLAG_LOADING", false);
              this.$messageSuccess("Hủy đơn hàng thành công");
            })
            .catch((error) => {
              this.$store.dispatch("FLAG_LOADING", false);
              console.log(error);
              this.$messageError("Có lỗi xảy ra, vui lòng thử lại");
            });
        }
      });
    },
    saveInfoChange() {
      if (this.form.receivedPhone.indexOf("^d+$") !== -1) {
        alert("Số điện thoại không chứa ký tự đặc biệt");
        return false;
      } else if (
        !this.form.customerName ||
        !this.form.salerCode ||
        !this.form.salerName ||
        !this.form.receivedName ||
        !this.form.receivedPhone ||
        !this.form.receivedAddress
      ) {
        this.$messageError("Bạn cần điền đủ thông tin đơn hàng");
        return false;
      }
      if (this.form.paymentTime) {
        this.form.paymentTime = Number(this.form.paymentTime);
      }
      Swal.fire({
        title: "Lưu thông tin",
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "md-button md-success",
        cancelButtonClass: "md-button md-danger",
        confirmButtonText: "OK",
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          let bits = localStorage.getItem("bits");
          let confirm = this.db.collection(process.env.VUE_APP_ORDER + bits);
          this.$store.dispatch("FLAG_LOADING", true);
          let tmpObject = Object.assign({}, this.form);
          console.log(tmpObject);
          delete tmpObject.orderId;
          confirm
            .doc(this.billSelected.id)
            .update(tmpObject)
            .then(() => {
              this.$store.dispatch("FLAG_LOADING", false);
              this.$messageSuccess("Lưu thông tin thành công");
            })
            .catch((error) => {
              this.$store.dispatch("FLAG_LOADING", false);
              console.log(error);
              this.$messageError("Có lỗi xảy ra, vui lòng thử lại");
            });
        }
      });
    },
    addProduct() {
      this.isAddProducts = true;
    },
    changeItem(index) {
      this.itemChange = index;
      this.isChangeItem = true;
    },
    confirmChangeItem(e) {
      this.itemChange = "";
      this.isChangeItem = false;
      if (!e.data) {
        return false;
      }
      let cartItems = [];
      Object.assign(cartItems, this.form.cartItems);
      cartItems[e.index] = {
        amount: 0,
        discountAmount: e.discountAmount || 0,
        discountValue: e.discountValue || 0,
        number: 0,
        packMethod: "",
        pictureUrl: e.data.pictureUrl[0] ? e.data.pictureUrl[0].url : "",
        productCost: parseInt(e.data.price),
        productId: e.data.productId,
        productName: e.data.name,
        saleOffAmount: 0,
        saleOffValue: e.data.saleOffValue,
      };
      this.form.cartItems = cartItems;
      let _cartItems = [];
      Object.assign(_cartItems, this.valueFormatted.cartItems);
      _cartItems[e.index] = {
        discountValue: this.formatNumber(e.data.discountValue || 0),
        discountAmount: this.formatNumber(e.data.discountAmount || 0),
        saleOffValue: this.formatNumber(e.data.saleOffValue),
      };
      this.valueFormatted.cartItems = _cartItems;
    },
    smallAlertModalHide(e) {
      this.isAddProducts = false;
      this.isChangeItem = false;
      e.forEach((item) => {
        this.isEdit.push({
          value: false,
        });
        let bits = localStorage.getItem("bits");
        var listPromotion = [];
        this.db
          .collection(process.env.VUE_APP_NEWS + bits)
          .where("type", "==", "Khuyến mại")
          .get()
          .then((doc) => {
            doc.forEach((news) => {
              if (news.data().listProduct.productId === item.data.productId) {
                listPromotion.push(news.data().title);
              }
            });
          });
        this.form.cartItems.push({
          promotion: [...listPromotion],
          amount: 0,
          discountAmount: item.data.discountAmount || 0,
          discountValue: item.data.discountValue || 0,
          number: 0,
          packMethod: "",
          pictureUrl: item.data.pictureUrl.length
            ? item.data.pictureUrl[0].url
            : "",
          productCost: parseInt(item.data.price),
          productId: item.data.productId,
          productName: item.data.name,
          saleOffAmount: 0,
          saleOffValue: item.data.saleOffValue ? item.data.saleOffValue : 0,
          unit: item.data.unit,
          warehouse: item.data.warehouse,
        });
        this.valueFormatted.cartItems.push({
          discountValue: this.formatNumber(item.data.discountValue),
          saleOffValue: this.formatNumber(item.data.saleOffValue),
        });
        this.isShowDialog = true;
        this.cartSelected = this.form.cartItems[this.form.cartItems.length - 1];
        this.indexSelected = this.form.cartItems.length - 1;
      });
    },
    editCartItem(item, index) {
      this.isShowDialog = true;
      this.cartSelected = item;
      this.indexSelected = index;
    },
    conpleteEdit(index) {
      this.isEdit[index].value = false;
    },
    updateCartItem(cartItem) {
      Object.assign(this.form.cartItems[this.indexSelected], cartItem);
      this.isShowDialog = false;
      this.cartSelected = {};
      this.indexSelected = null;
    },
    cancelUpdateCartItem() {
      this.indexSelected = null;
      this.isShowDialog = false;
      this.cartSelected = {};
    },
    formatNumber(item) {
      return item;
    },
    formatValues() {
      this.valueFormatted.vat = this.formatNumber(this.form.vat);
      this.valueFormatted.discountValue = this.formatNumber(
        this.form.discountValue
      );
      this.form.cartItems.forEach((item) => {
        this.valueFormatted.cartItems.push({
          discountValue: this.formatNumber(item.discountValue),
          saleOffValue: this.formatNumber(item.saleOffValue),
        });
      });
    },
    convertValues(value) {
      if (value < 0) {
        value = 0;
      }
      let a = value || 0;
      a = parseFloat(a);
      if (parseFloat(a) === NaN || parseFloat(a) < 0) {
        this.$messageError("không được điền số âm");
        value = 0;
        a = 0;
        return parseFloat(a);
      } else {
        return parseFloat(a);
      }
    },
    caculatValue() {
      this.debt -= this.form.amount;
      let tongTien = 0;
      this.form.cartItems.forEach((item) => {
        let s = item.productCost * item.number;
        // item.saleOffAmount = (s * item.saleOffValue) / 100;
        item.discountAmount = Math.round((s * item.discountValue) / 100);
        item.amount =
          ((s - item.discountAmount - item.saleOffAmount) / 100) * 100;
        tongTien += (item.amount / 100) * 100;
      });
      this.form.vatAmount = ((tongTien * this.form.vat) / 1000) * 10;
      this.form.amount =
        Math.round((tongTien + this.form.vatAmount) / 100) * 100;
      this.debt += this.form.amount;
    },
    warningOutDeposit() {
      Swal.fire({
        title: `Không thành công`,
        text: `Tài khoản cộng tác viện hiện không đủ`,
        buttonsStyling: false,
        confirmButtonClass: "md-button md-success md-dense",
      });
    },
    checkDepositPartner() {
      var bits = localStorage.getItem("bits");
      this.db
        .collection(process.env.VUE_APP_USER + bits)
        .where("employeeCode", "==", this.form.salerCode)
        .get()
        .then((doc) => {
          doc.forEach((item) => {
            if (item.data().permission === "Cộng tác viên") {
              if (
                parseFloat(item.data().deposit) - parseFloat(this.form.amount) >
                0
              ) {
                this.updateBill();
              } else this.warningOutDeposit();
            } else this.updateBill();
          });
        });
    },
    updateBillPartner(depositPartner, deposit) {
      if (depositPartner < 0) {
        Swal.fire({
          title: `Không thành công`,
          text: `Số dư khả dụng không đủ để giao dịch, cộng tác viên cần nạp thêm ${this.formatMoney(
            depositPartner * -1
          )}đ `,
          buttonsStyling: false,
          confirmButtonClass: "md-button md-success md-dense",
        });
      } else {
        Swal.fire({
          title: `${
            this.form.status === 0
              ? "Xác nhận đơn hàng"
              : this.form.status === 1
              ? "Giao hàng"
              : this.form.status === 2
              ? "Hoàn tất"
              : ""
          }`,
          text: `Tài khoản cộng tác viên: ${this.formatMoney(deposit)}đ`,
          type: "warning",
          showCancelButton: true,
          confirmButtonClass: "md-button md-success",
          cancelButtonClass: "md-button md-danger",
          confirmButtonText: "Xác nhận",
          buttonsStyling: false,
        }).then((result) => {
          if (result.value) {
            this.updateBill();
          }
        });
      }
    },
    checkPartner(partner) {
      var bits = localStorage.getItem("bits");
      var depositPartner =
        partner.deposit -
        (this.form.status === 0 ? parseInt(this.form.amount) : 0);
      this.db
        .collection(process.env.VUE_APP_ORDER + bits)
        .where("salerCode", "==", partner.employeeCode)
        .get()
        .then((res) => {
          res.forEach((item) => {
            if (
              (item.data().status === 1 || item.data().status === 2) &&
              item.data().paymentMethod === "Công nợ"
            ) {
              depositPartner -= parseInt(item.data().amount);
            }
          });
          this.updateBillPartner(depositPartner, partner.deposit);
        });
    },
    confirmBill() {
      if (this.form.receivedPhone.indexOf("^d+$") !== -1) {
        alert("Số điện thoại không chứa ký tự đặc biệt");
        return false;
      }
      var bits = localStorage.getItem("bits");
      this.db
        .collection(process.env.VUE_APP_USER + bits)
        .where("employeeCode", "==", this.form.salerCode)
        .get()
        .then((doc) => {
          doc.forEach((item) => {
            if (item.data().permission === "Cộng tác viên") {
              if (this.form.paymentMethod === "Thu tiền ngay") {
                Swal.fire({
                  title: `${
                    this.form.status === 0
                      ? "Xác nhận đơn hàng"
                      : this.form.status === 1
                      ? "Giao hàng"
                      : this.form.status === 2
                      ? "Hoàn tất"
                      : ""
                  }`,
                  text: `Thu tiền ngay khi giao hàng`,
                  type: "warning",
                  showCancelButton: true,
                  confirmButtonClass: "md-button md-success",
                  cancelButtonClass: "md-button md-danger",
                  confirmButtonText: "Xác nhận",
                  buttonsStyling: false,
                }).then((result) => {
                  if (result.value) {
                    this.updateBill();
                  }
                });
              } else this.checkPartner(item.data());
            } else {
              Swal.fire({
                title:
                  this.debt > this.debtLimit
                    ? "Vượt mức công nợ"
                    : `${
                        this.form.status === 0
                          ? "Xác nhận đơn hàng"
                          : this.form.status === 1
                          ? "Giao hàng"
                          : this.form.status === 2
                          ? "Hoàn tất"
                          : ""
                      }`,
                text: `Công nợ hiện tại: ${
                  this.debt < 0 ? "0đ" : this.formatMoney(this.debt)
                },
                  Hạn mức công nợ: ${this.formatMoney(this.debtLimit)}`,
                type: "warning",
                showCancelButton: true,
                confirmButtonClass: "md-button md-success",
                cancelButtonClass: "md-button md-danger",
                confirmButtonText: "Xác nhận",
                buttonsStyling: false,
              }).then((result) => {
                if (result.value) {
                  this.updateBill();
                }
              });
            }
          });
        });
    },
    formatDate() {
      var timeFormated = new Date();
      let hours = timeFormated.getHours();
      let minutes = timeFormated.getMinutes();
      let seconds = timeFormated.getSeconds();

      let time =
        hours.toString().padStart(2, 0) +
        ":" +
        minutes.toString().padStart(2, 0) +
        ":" +
        seconds.toString().padStart(2, 0);
      let date =
        timeFormated.getDate().toString().padStart(2, 0) +
        "/" +
        (timeFormated.getMonth() + 1).toString().padStart(2, 0) +
        "/" +
        timeFormated.getFullYear().toString();
      return date + " " + time;
    },
    updateBill() {
      if (this.form.status === 0) {
        this.form.validDate = this.formatDate();
        this.form.status = 1;
      } else this.form.status++;
      this.form.status === 2
        ? (this.form.transportTime = this.formatDate())
        : this.form.status === 3
        ? (this.form.completedTime = this.formatDate())
        : console.log("");
      if (this.form.paymentTime) {
        this.form.paymentTime = Number(this.form.paymentTime);
      }
      let bits = localStorage.getItem("bits");
      let confirm = this.db.collection(process.env.VUE_APP_ORDER + bits);
      this.$store.dispatch("FLAG_LOADING", true);
      confirm
        .doc(this.billSelected.id)
        .get()
        .then((doc) => {
          if (doc.data().status === 4) {
            this.$messageError("Đơn đã bị hủy");
            this.closeBillDetail();
            this.$store.dispatch("FLAG_LOADING", false);
            this.form.status = 4;
            return false;
          } else this.confirm();
        })
        .catch((error) => {
          this.$messageError("Lỗi, vui lòng thử lại");
          console.log(error);
          return false;
        });
    },
    confirm() {
      let bits = localStorage.getItem("bits");
      let tmpObject = Object.assign({}, this.form);
      delete tmpObject.orderId;
      this.db
        .collection(process.env.VUE_APP_ORDER + bits)
        .doc(this.billSelected.id)
        .update(tmpObject)
        .then(() => {
          this.$store.dispatch("FLAG_LOADING", false);
          this.$notify({
            timeout: 3000,
            type: "success",
            message: "Thành công!!!",
            icon: "add_alert",
            horizontalAlign: "right",
            verticalAlign: "top",
          });
        })
        .catch((error) => {
          this.$store.dispatch("FLAG_LOADING", false);
          this.$messageError(error.message);
          this.form.status--;
        });
    },
    closeBillDetail() {
      if (!this.isAddBill) {
        this.$emit("close", this.billSelected.id);
      } else this.$emit("addBillClose");
    },
    updateValue() {
      this.form.vat = this.convertValues(this.valueFormatted.vat);
      this.form.discountValue = this.convertValues(
        this.valueFormatted.discountValue
      );
      this.valueFormatted.cartItems.forEach((item) => {
        let i = this.valueFormatted.cartItems.indexOf(item);
        this.form.cartItems[i].discountValue = this.convertValues(
          item.discountValue
        );
        this.form.cartItems[i].saleOffValue = this.convertValues(
          item.saleOffValue
        );
      });
    },
  },
  computed: {
    ...mapGetters(["flagLoading"]),
    changevalue() {
      let a = "";
      this.form.cartItems.forEach((cart) => {
        a += cart.amount;
      });
      return this.form.vat + this.valueFormatted.discountValue + a;
    },
  },
  watch: {
    billSelected() {
      this.form = this.billSelected.data;
    },
    changevalue() {
      // this.updateValue();
      this.caculatValue();
    },
  },
};
</script>
<style lang="scss" scoped>
.bill-header {
  text-align: center;
}

.imgProducts {
  width: auto;
  height: 8vh;
}
.cell-img {
  padding: 3px;
}
#customers {
  font-family: "Trebuchet MS", Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

#customers td,
#customers th {
  border: 1px solid #ddd;
  padding: 8px;
  max-width: 20vh;
}

#customers tr:nth-child(even) {
  background-color: #f2f2f2;
}

#customers tr:hover {
  background-color: #ddd;
}

#customers th {
  padding-top: 12px;
  padding-bottom: 12px;
  background-color: rgba(0, 165, 14, 0.356);
  color: rgb(0, 0, 0);
  font-style: normal;
  font-weight: normal;
}
.number {
  text-align: right;
}
.input-table {
  width: 70px;
}

.input-table2 {
  width: 100px;
}
.button-remove {
  position: absolute;
  bottom: 3vh;
  left: 3vh;
}
.disabled {
  cursor: not-allowed;
}
@media only screen and (max-width: 600px) {
  #customers {
    overflow-x: scroll;
  }
}
</style>
